
import { get, set, del, clear } from 'idb-keyval';

export const cacheData = async (key: string, data: any, ttlMinutes: number = 60) => {
    const cacheEntry = {
        data,
        expiry: Date.now() + ttlMinutes * 60 * 1000
    };
    await set(key, cacheEntry);
};

export const getCachedData = async <T>(key: string): Promise<T | null> => {
    const entry = await get(key);
    if (!entry) return null;
    
    if (Date.now() > entry.expiry) {
        await del(key);
        return null;
    }
    
    return entry.data as T;
};

export const invalidateCache = async (key: string) => {
    await del(key);
};

export const clearCache = async () => {
    await clear();
};
